import { GlobalDomOpsService } from '@acepteam/globalspack';
import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/core/services';

@Component({
  selector: 'app-chapter-lobby',
  templateUrl: './chapter-lobby.component.html',
  styleUrls: ['./chapter-lobby.component.css']
})
export class ChapterLobbyComponent implements OnInit {

  
  constructor(private dataSvc: DataService, private globalDomopsSvc: GlobalDomOpsService) { }


  lobbyData = this.dataSvc.chapterLobbydata;

  ngOnInit(): void {    

    this.globalDomopsSvc.hidewait();
  }

  goback()
  {
    window.history.back();
  }

}
